import * as React from "react";
import { InView } from "react-intersection-observer";

export const InViewContainer = ({
  children,
  as,
  classes,
  threshold,
  triggerOnce,
}) => {
  return (
    <InView
      as={as || "div"}
      threshold={threshold || 0.2}
      triggerOnce={triggerOnce || false}
    >
      {({ inView, ref }) => (
        <div ref={ref} className={`${inView && "visible"} ${classes}`}>
          {children}
        </div>
      )}
    </InView>
  );
};
